<div *ngIf="showForm">
  <div class="row">
    <div class="col-12">
      <ngb-alert
        [type]="color"
        [dismissible]="false"
        class="text-center w-100 custom-alert"
        [class.ArabicFont]="globalService.isRTL"
      >

        <span [innerHTML]="formattedMessage"></span>

        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="Close()"
        >
          <span aria-hidden="true">&times;</span>
        </button>

      </ngb-alert>
    </div>
  </div>
</div>